import {
	mapGetters,
	mapActions
} from 'vuex';

import {
	EventBus
} from '@/support/event-bus';

import toastr from '@/support/toastr';

export default {
	name: 'EvaluationQuestionSave',
	props: {
		question: {
			type: Number,
			default: undefined
		}
	},
	computed: {
		...mapGetters([
			'getLoggedUser',
			'getClass',
			'evaluationQuestionsList'
		])
	},
	methods: {
		...mapActions([
			'saveEvaluationQuestion'
		]),
		saveQuestion() {

			this.saveEvaluationQuestion({
				userId: this.getLoggedUser.id,
				schoolClassId: this.getClass.schoolClassId,
				data: this.evaluationQuestionsList
			}).then((response) => {

				toastr.success(this.$gettext('Questionário salvo com sucesso!'));
				EventBus.$emit('evaluationQuestionSaved', response.data);

			});

		}
	}
};



// WEBPACK FOOTER //
// ./sources/domains/evaluation/question-save/index.js